import { Outlet } from "react-router-dom";

function DashboardIndex() {
  return (
    <div className="h-full w-full">
      <Outlet />
    </div>
  );
}

export default DashboardIndex;
